import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef,  OnChanges, SimpleChanges, ElementRef, ViewChild} from '@angular/core';

import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';
import {trigger, transition, style, animate, query, stagger, state} from '@angular/animations';
import { AfterViewInit, PLATFORM_ID, Inject, HostListener,} from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/first';
import { interval } from 'rxjs/observable/interval';
import 'rxjs/add/operator/pairwise';
import { Subject } from 'rxjs/Subject';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { APP_SETTINGS, DeviceInfo, DEVICE_INFO } from 'angular-engine/modules/ng-express-engine/tokens';
import { MobileNavigationService } from 'angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';;
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { VideoPlayerControlService } from "angular-engine/engine/service/ui/videoplayer/videoplayer-control.service";
import * as moment from 'moment';

@Component({
  selector: 'video-container',
  templateUrl: './video-container.template.html',
  styleUrls: ['./video-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoContainer extends StaticContainer {
  @ViewChild('seasonpicker') seasonpicker:ElementRef;
  @Input() unfold: boolean;
  @Input() tabs : Array<string> = [];
  @Input() listConfig : MediaCellConfig = new MediaCellConfig();
  @Input() groupedRows : Array<any> = [];
  
  public nag : boolean = false;
  public viewsLeft : number;
  public limitReached = true;
  public foundation = false;

  public donationLink:string = "";

    rows: Array<any>
    selectedSeason: any;
    seasons: Array<any>;
    profiles ;
    extras : any;
    playlist: any;
    segments: any;
    item: any;
  public isLive: boolean = false;
  public isTheatreMode : boolean = false;

    groupLoaded: boolean = false;
    
    profileService : BehaviorSubject<any>;
    contentSubscription : Subscription;
    refreshSubscription : Subscription;
    eventSubscription: Subscription;
    private oauthSubscription: Subscription;

    lastUpdated: any;

    public title: string;
    public subTitle: string;
    public description: any;
    public series: any;
    public initialIndex: number = 1;
    
    public isLoggedIn: boolean = false;
    public userProfile:any;
    public userId:number = -1;
    public showUserRelatedSharingItems: boolean = false;
    
    constructor(
      protected coreEffects: CoreEffects,
      @Inject(PLATFORM_ID) protected platformId: string,
      protected ref: ChangeDetectorRef,
      protected router: Router,
      protected route: ActivatedRoute,
      protected metaService: MetaService,
      protected location: Location,
      @Inject(APP_SETTINGS) protected settings: any,
      protected mobileNavigationService: MobileNavigationService,
      @Inject(DEVICE_INFO) device: DeviceInfo,
      protected eventInteractions:EventInteraction,
      protected authService: UserLoginService,
      private playerService: VideoPlayerControlService
      
    ) {
      super(coreEffects, platformId, ref, router, route, metaService, 
        location, settings, mobileNavigationService, device, eventInteractions);

        if(settings['AUTH_ENABLED'])
        {
          this.showUserRelatedSharingItems = true;
        }
    }  
  ngOnInit(){
    super.ngOnInit();
    this.lastUpdated = Date.parse(new Date().toUTCString());
    this.profileService = new BehaviorSubject(null);
    
    this.isLive = (this.router.url.indexOf('/streams') >= 0);
    
    this.checkVideoControlsState()

    if (!this.isServer){
      this.userProfile = this.coreEffects.getInternalStateValue('user_profile');
      if(this.userProfile && this.userProfile.id)
      {
        this.userId = this.userProfile.id;
      }

      if (!this.isLive){
        
          this.limitReached = false;
          this.ref.detectChanges();
        
      }
      else{
        this.limitReached = false;
      }
    }
    else{
      this.limitReached = false;
    }

    this.contentSubscription = this.content.takeUntil(this.ngUnsubscribe).subscribe(result => {
      if(!result || !result.meta)
      {
        return;
      }

      this.item= result;

      if(result.meta && result.meta.series)
      {
        this.foundation = result.meta.series.is_foundation === true;
      }
      
      if(result.meta.obj_type == 'Stream' && !this.refreshSubscription)
      {
        let url = result.meta.poll_url;
        if(this.userId != -1)
        {
          this.donationLink = `https://donate.nra.org/nratv/donate?ek=Y9ATVDNT&utm_source=user_${this.userId}&utm_medium=nratv_player&utm_campaign=donate_progressive_disarmament&utm_content=live`;
        }
        else
        {
          this.donationLink = `https://donate.nra.org/nratv/donate?ek=Y9ATVDNT&utm_source=nologin&utm_medium=nratv_player&utm_campaign=donate_progressive_disarmament&utm_content=live`;
        }
        this.title = result.meta.title;
        this.subTitle = result.meta.sub_head;
        this.description = result.meta.description ? result.meta.description : result.meta.summary;
        if(result.meta.series && result.meta.series.unique_id)
        {
          this.series = result.meta.series;
        }
        else
        {
          this.series = null;
        }

        if(!this.isServer)
        {
          const intervalObservable = interval(this.settings['AUTO_REFRESH_INTERVAL']);
          this.refreshSubscription = intervalObservable.takeUntil(this.ngUnsubscribe).subscribe(val => {
            //console.log(val);
            this.coreEffects.getFreshData(url).takeUntil(this.ngUnsubscribe).subscribe(results =>{
                    if (results && results.meta){
                      const lastApiUpdated = Date.parse(results.meta['updated_at']);
                      if (lastApiUpdated != this.lastUpdated){

                        this.title = results.meta.title;
                        this.subTitle = results.meta.sub_head;
                        this.description = results.meta.description ? results.meta.description : results.meta.summary

                        if(this.isPhone)
                        {
                          let resultCopy = JSON.parse(JSON.stringify(results));
                          resultCopy.meta.title = "About";
                          resultCopy.rows = [];
                          if(results.meta.series && results.meta.series.unique_id)
                          {
                            resultCopy.rows.unshift({meta:{title:"Episodes"}}); 
                            this.initialIndex = 2;
                          }
                          else
                          {
                            this.initialIndex = 1;
                          }

                          resultCopy.rows = resultCopy.rows.concat(this.rows);
                          this.mobileNavigationService.setData(resultCopy);
                        }

                        if(results.meta.series && results.meta.series.unique_id)
                        {
                          this.series = results.meta.series;
                        }
                        else
                        {
                          this.series = null;
                        }
                        

                        this.lastUpdated = lastApiUpdated;
                        this.ref.detectChanges();
                      }
                    }
            });
          });
        }
      }
      else if(!(result.meta.obj_type == 'Stream'))
      {
          let video =  result.meta.hasOwnProperty('video')  ? result.meta.video.meta : result.meta;
          this.title = result.meta.title;
          this.subTitle = video.sub_head;
          this.description = result.meta.description;

          if(this.userId != -1)
          {
            this.donationLink = `https://donate.nra.org/nratv/donate?ek=Y9ATVDNT&utm_source=user_${this.userId}&utm_medium=nratv_player&utm_campaign=donate_progressive_disarmament&utm_content=${video.slug}`;
          }
          else
          {
            this.donationLink = `https://donate.nra.org/nratv/donate?ek=Y9ATVDNT&utm_source=nologin&utm_medium=nratv_player&utm_campaign=donate_progressive_disarmament&utm_content=${video.slug}`;
          }

          if(result.meta.series && result.meta.series.unique_id)
          {
            this.series = result.meta.series;
          }
          else
          {
            this.series = null;
          }
      }

      let resultCopy = JSON.parse(JSON.stringify(result));
      resultCopy.meta.title = "About";

      if (result && result.rows && this.settings['GROUPED_VIDEO_ROWS'] === true) {
        this.rows = new Array<any>();
        this.seasons = new Array<any>();
        this.groupedRows = new Array<any>();

        this.groupLoaded = false;
        result.rows.forEach(r => {
            if ( r.meta && r.meta.grouped && !this.isPhone){
              if(r.meta.obj_type == "PlayList")
              {
                r.meta.title = "Playlist";
              }
              this.groupedRows.push( r );
              
            }
            else if( r.meta && r.meta.title == "Profiles"){
                this.profiles = this.profileService.asObservable();
                this.coreEffects.getAsyncChildDataAsObservable(this.profileService, r, this.route.snapshot.params, true)
              }
            else{
              this.rows.push( r );
            }

        });
        this.groupLoaded = true;
        if(this.isPhone)
        {
          resultCopy.rows = [];
          if(result.meta.series  && result.meta.series.unique_id)
          {
            resultCopy.rows.unshift({meta:{title:"Episodes"}}); 
            this.initialIndex = 2;
          }

          resultCopy.rows = resultCopy.rows.concat(this.rows);
          this.mobileNavigationService.setData(resultCopy);
          
        }
        this.ref.detectChanges();
      }
    });

  this.eventSubscription = this.eventInteractions.subscribe( interaction =>{
      if( interaction.key == 'toggle-video-content' ){
        this.unfold = interaction.message;
        this.ref.detectChanges();
      }
      else if( interaction.key == 'theatremode' ){
        this.isTheatreMode = interaction.message.theatre;
        this.ref.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
    if(this.isPhone)
    {
        this.mobileNavigationService.registerClientObject(1, this.seasonpicker);
    }
  }

  public position():string{
    if(this.isPhone)
    {
        const position = this.mobileNavigationService.windowWidth;
        return 'translateX(' + position + 'px)';
    }

    return '';
  }

  public login(){
    this.coreEffects.login();
    this.isLoggedIn && this.checkLoginStatus();
  }

  public get videoMeta():string{
    if (!this.item || !this.item.meta ){
      return ;
    }
    let  str: string;
    let video =  this.item.meta.hasOwnProperty('video')  ? this.item.meta.video.meta : this.item.meta;
    if( !video.series && video.runtime){
        str = video.runtime;
    }else if (video.series && video.episode ){
        str = video.series.title.toUpperCase() + " • " + 'S' + video.episode.season.number+ " E" + video.episode.number  + " • " + video.runtime;
    }
    else{
      str = '';
    }

    return str;
  }

  public replaceString(str : string){
    return str.replace('thumb_416x', "optimized");
  }

  public get seasonnumber():number{
    if (!this.item || !this.item.meta ){
      return null;
    }

    let video =  this.item.meta.hasOwnProperty('video')  ? this.item.meta.video.meta : this.item.meta;

    if(video.episode)
    {
      return video.episode.season.number;
    }

    return null;
  }

  public get episodenumber():number{
    if (!this.item || !this.item.meta ){
      return ;
    }

    let video =  this.item.meta.hasOwnProperty('video')  ? this.item.meta.video.meta : this.item.meta;

    if(video.episode)
    {
      return video.episode.number;
    }

    return null;
  }



    public checkLoginStatus(){
      if(this.isServer){
          this.isLoggedIn = false;
      }
  }

  ngOnDestroy(){
    super.ngOnDestroy();
    if (!this.isServer){   
      const videoElement = document.getElementById('singleVideo') as HTMLVideoElement;
      if (videoElement && videoElement.nodeName.toUpperCase() == "VIDEO"){
        videoElement.pause();
        videoElement.src =""; // empty source
        videoElement.load();
      }
    }

    if (this.contentSubscription){
      this.contentSubscription.unsubscribe()
      this.contentSubscription = null;
    }
    if (this.eventSubscription){
      this.eventSubscription.unsubscribe();
      this.eventSubscription = null;
    }
    if (this.refreshSubscription){
      this.refreshSubscription = null;
    }
    if (this.profileService){
      this.profileService.complete();
      //this.profileService.unsubscribe();
      this.profileService = null;
    }
    if (this.oauthSubscription){
      this.oauthSubscription.unsubscribe();
      this.oauthSubscription = null;
    }

  }

  checkVideoControlsState(): any {
      const controls = this.playerService.getPlayerControlState()
      if (controls) {
        this.isTheatreMode = controls.isTheaterMode;
      }
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/video-container/video-container.component.ts